<header id="Header" >
    <nav class="navbar-header" #header id="HeaderNavbar" [ngClass]="{'menu-overlay':hasOverlay,'search-overlay':displaySearch, 'scrolled':scrolled}">
      <div class="header-container">
        <div class="navbar-top">
          <a class="logo" [routerLink]="'/'" (click)="onDisplaySearchChange(false)">
            <logo></logo>
          </a>
          <div class="tools">
            <ul>
              <li class="link link-home">
                <a [routerLink]="'/'" (click)="onDisplaySearchChange(false)">
                  <i class="lvi-thel-accueil"></i>
                </a>
              </li>
              <li class="link" (click)="onSearchClick()"><i class="lvi-thel-loupe"></i></li>
              <li class="link link-bookmarks" (click)="displaySearch=false" [routerLink]="[themeService.lang.current == 'fr' ? environment.bookmarkFrUrl : environment.bookmarkEnUrl]"><i class="lvi-thel-coeur-vide"></i><span *ngIf="bookmarksCount>0">{{bookmarksCount}}</span></li>
              <li class="link" (click)="displaySearch=false" [routerLink]="[themeService.lang.current == 'fr' ? environment.webcamsFrUrl : environment.webcamsEnUrl]"><i class="lvi-thel-webcam"></i></li>
              <li class="languages" [ngClass]="{'open':displayLanguages}">
                <span class="link current-language"  *ngIf="themeService.currentLanguage" (click)="displayLanguages = !displayLanguages">{{themeService.currentLanguage.slug|uppercase}}
                  <i class="lvi-icon-chevron-down"></i>
                </span>
                <ul class="others">
                  <ng-container *ngFor="let language of themeService.languages">
                    <li class="link" *ngIf="language.slug != themeService.currentLanguage?.slug">
                      <span class="link" (click)="onLanguageClick(language.slug)">{{language.slug|uppercase}}</span>
                    </li>
                  </ng-container>
                </ul>
              </li>
            </ul>
          </div>
          <div class="menu-mobile-toggle" (click)="onMenuResponsiveClick()"><i class="lvi-icon-menu"></i></div>
        </div>
        <div *ngIf="navigation" class="header-navigation" #nav>
          <div class="mobile-back-button" #mobileBackNav>< <span i18n="@@Return">Retour</span></div>
          <ul>
            <li class="link" *ngFor="let navItem of navigation"><head-menu-item [scrolled]="scrolled||displaySearch" [navigationItem]="navItem" [hasOverlay]="hasOverlay" (navigationItemChange)="onNavItemChange($event)"></head-menu-item></li>
          </ul>
        </div>

      </div>
    </nav>
  <div class="header-search-container" #search [ngClass]="{'active':displaySearch}">
    <search [textsearch]="textsearch" [displaySearch]="displaySearch" (displaySearchChange)="onDisplaySearchChange($event)" [headerScrolled]="scrolled"></search>
  </div>

</header>
